import styled from 'styled-components';
import type { ImageValue } from '@elfsight/configurator-contracts';
import { useSettings } from '@wu/widget-core';
import { Icon } from '../../../common';

export interface IconsItemProps {
  data: {
    icon: ImageValue;
    hint: string;
  };
  className?: string;
}

export function IconsItem({ data, className = '' }: IconsItemProps) {
  const { icon, hint } = data;

  const {
    textColor,
    colorScheme,
    itemNameFontStyle: { fontSize }
  } = useSettings();

  const iconColor = {
    light: '#111',
    dark: '#fff',
    custom: textColor
  }[colorScheme];

  return (
    <Component className={className} title={hint}>
      {icon && <Icon icon={icon} size={fontSize} fill={iconColor} alt="" />}
    </Component>
  );
}

const Component = styled.div`
  display: flex;
  align-items: center;
`;
